import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import Aura from '@primeuix/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { MessageService } from 'primeng/api';
import { appRoutes } from './app.routes';
import { authInterceptor } from './app/core/auth/auth.interceptor';
import { loadingInterceptor } from './app/core/loading/loading.interceptor';
import { SERVICIOS_REPORTES } from './app/pages/reportes/core/catalogo-reportes.service';
import { DireccionTrabajoReportesService } from './app/pages/reportes/direccion-trabajo-reportes/direccion-trabajo-reportes.service';
import { PreviredReportesService } from './app/pages/reportes/previred-reportes/previred-reportes.service';
import { SiiReportesService } from './app/pages/reportes/sii-reportes/sii-reportes.service';
import { TgrReportesService } from './app/pages/reportes/tgr-reportes/tgr-reportes.service';

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(appRoutes, withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }), withEnabledBlockingInitialNavigation()),
        provideHttpClient(withFetch(), withInterceptors([loadingInterceptor, authInterceptor])),
        provideZonelessChangeDetection(),
        MessageService,
        { provide: SERVICIOS_REPORTES, multi: true, useExisting: SiiReportesService },
        { provide: SERVICIOS_REPORTES, multi: true, useExisting: PreviredReportesService },
        { provide: SERVICIOS_REPORTES, multi: true, useExisting: DireccionTrabajoReportesService },
        { provide: SERVICIOS_REPORTES, multi: true, useExisting: TgrReportesService },
        providePrimeNG({ theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } } })
    ]
};
